<template>
	<div class="post-page-container page">
		<v-skeleton-loader v-if="this.isLoading" v-bind="attrs" type="card"></v-skeleton-loader>
		<Post v-else-if="!this.isLoading && !this.notFound" :post="this.post" />

		<NewsFeedEmpty
			v-if="!this.isLoading && this.notFound"
			class="mt-7"
			title="Thread not found at this moment."
			description="Check back later."
		/>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Post from '@/components/Post/Post'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import Dwh from '@/mixins/Dwh'
import _ from 'lodash'

export default {
	name: 'PostPage',
	mixins: [Dwh],
	components: {
		NewsFeedEmpty,
		Post,
	},
	data() {
		return {
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
		}
	},
	computed: {
		...mapGetters('post', ['post', 'isLoading', 'postNotFound']),

		notFound() {
			return this.postNotFound
		},
	},
	methods: {
		...mapActions('post', ['getPost']),
	},
	watch: {
		post(newValue, oldValue) {
			if (!_.isEmpty(newValue) && _.isEmpty(oldValue)) {
				this.sendTrigger({
					category: 'Content',
					action: 'view_post',
					module: 'News Feed',
					data: newValue.thread_id,
					title: newValue.thread_title,
					content_chapter_id: newValue.chapter_id ? [newValue.chapter_id] : null,
				})
			}
		},
	},
	created() {
		if (this.$route.params.id !== undefined) {
			this.getPost(this.$route.params.id)
		}
	},
}
</script>

<style lang="scss">
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}

@media screen and (min-width: 1200px) {
	.post-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.post-page-container {
		max-width: 600px;
	}
}
</style>
